const colors = [
  '#ff000033',
  '#9ea64133',
  '#ffa70033',
  '#7c66d933',
  '#ff008033',
  '#314e5233',
  '#9ea64133',
  '#5da9dd33',
  '#e1d8f433',
  '#d1ecfd',
  '#fecfcc',
];

export default colors;
